import compress from 'browser-image-compression'

const MAX_SIZE = 0.7
const MAX_WIDTH = 2048
const fileResizeInBrowser = (file) => {
    if (file.compressed || file.wasProcessedBefore) {
        return new Promise((resolve) => resolve(file))
    }

    file.compressed = true

    return compress(file, {
        maxSizeMB: MAX_SIZE,
        maxWidthOrHeight: MAX_WIDTH,
    })
}

export default fileResizeInBrowser